var app = angular.module('leonardo');

var LayoutStates = function ($stateProvider, AuthenticatedResolvers) {
  $stateProvider.state('layout-no-cols', {
    templateUrl: 'views/templates/layout/no-cols.html'
  });

  $stateProvider.state('authenticated', {
    abstract: true,
    resolve: AuthenticatedResolvers,
    template: '<ui-view/>',
    ncyBreadcrumb: {
      skip: true
    }
  });

  $stateProvider.state('authenticated.layout-no-cols', {
    templateUrl: 'views/templates/layout/no-cols.html'
  });

  $stateProvider.state('authenticated.layout-main', {
    templateUrl: 'views/templates/layout/main.html',
    ncyBreadcrumb: {
      skip: true
    }
  });

  $stateProvider.state('authenticated.layout-minimal', {
    templateUrl: 'views/templates/layout/minimal.html',
    ncyBreadcrumb: {
      skip: true
    }
  });
};

app.config(['$stateProvider', 'AuthenticatedResolvers', LayoutStates]);
